export const REGENERATE_REPORT_LABELS = {
  BUTTON: 'Re-generate',
  BUTTON_REGENERATING: 'Re-generating...',
  MODAL_TITLE: 'Re-generate summary',
  MODAL_SUBTITLE:
    "Re-generating will create a new summary and remove all manual changes you've made. This action cannot be undone.",
  MODAL_PRIMARY: 'Regenerate',
  ERROR_TITLE: 'Error re-generating report',
  ERROR_DESCRIPTION: 'An error has occurred while re-generating the report',
} as const

export const ASSESSMENT_REPORT_LAYOUT_LABELS = {
  GENERATING_SUMMARY_TITLE: 'Generating summary...',
} as const

export const ASSESSMENT_REPORT_HEADER_LABELS = {
  SCORE: 'Assessment score',
  CONCLUDED_BY: 'Concluded by',
  EDITED: 'edited',
  BY: 'by',
} as const
